import React from "react";

function SocialHistory() {
  return (
    <div>
      <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
        <div className="header h-[13%] bg-[#FFCDD8] flex items-center justify-center rounded p-2">
          <h1 className="font-bold text-normal text-[#350c16] mt-3">
            Social History
          </h1>
        </div>
        <div className="body h-[75%] items-center scrollwidth bg-white overflow-y-auto border-t-2 border-t-[#FC1D52]">
          <div className="items-center m-3 p-2 text-sm border rounded-md">
            <p className="font-semibold">
              Social History:{" "}
              <span className="font-medium text-gray-500">
                No data available
              </span>
            </p>
            <p className="font-semibold">
              Occupation:{" "}
              <span className="font-medium text-gray-500">Not specified</span>
            </p>
            <p className="font-semibold">
              Marital Status:{" "}
              <span className="font-medium text-gray-500">Not provided</span>
            </p>
            <p className="font-semibold">
              Social relations with family:{" "}
              <span className="font-medium text-gray-500">No info</span>
            </p>
            <p className="font-semibold">
              Social relations with friends:{" "}
              <span className="font-medium text-gray-500">No details</span>
            </p>
            <p className="font-semibold">
              Social relations with community:{" "}
              <span className="font-medium text-gray-500">No data</span>
            </p>
            <p className="font-semibold">
              Social relations with people at work:{" "}
              <span className="font-medium text-gray-500">Not available</span>
            </p>
            <div className="ml-auto font-medium mt-2 flex justify-start">
              <h5 className="text-gray-500 font-semibold text-sm">
                Onset date: <span>2024-12-21</span>
              </h5>
            </div>
          </div>
        </div>
        <div className="footer h-[44px] bg-[#FFCDD8] rounded"></div>
      </div>
    </div>
  );
}

export default SocialHistory;
